import type {
  Product,
  SelectedProduct,
} from "../../../../constants/modelCompareData/types";

export const getNumberOfColumns = ({
  selectedProducts,
  selectedProductsLimit,
  products,
}: {
  selectedProducts: SelectedProduct[];
  selectedProductsLimit: number;
  products: Product[];
}) => {
  if (products.length <= 5) return products.length;

  if (selectedProducts.length === selectedProductsLimit)
    return selectedProductsLimit;

  if (selectedProducts.length === 1) return 3;

  return selectedProducts.length + 1;
};
